/* Tidel: the quote reference for /pages/request-quote. Not part of Ella.

   ONE FILE, TWO STATES. A Shopify contact form POSTs to /contact and comes back
   to the SAME url, so the form and the confirmation are two states of one page
   and one script has to serve both.

   IT DOES NOT KEY ON THE FORM ELEMENT. `{% form %}` wraps the success branch as
   well, so `form.tidel-quote-form--page` is present in BOTH states - keying on
   it would mint a fresh reference on the confirmation and never show the stored
   one. The discriminator is [data-tidel-quote-reference], which only the
   success branch renders.

     success state  read sessionStorage -> fill -> unhide -> drop the key
     form state     generate -> prepend a hidden input -> store on submit

   WHY THE INPUT IS CREATED HERE AND NOT IN LIQUID. A Liquid-rendered input with
   an empty value would put a blank "Reference" line at the top of every email
   from a visitor with JS off. Created here, no JS means no field at all, which
   is what "no reference is fine" actually looks like in the inbox.

   IT MUST BE FIRST. Shopify renders custom contact[...] fields in the email
   body in source order, so the input is prepended to the form and lands ahead
   of contact[Request type]. The form_type and utf8 hidden inputs Shopify emits
   are not contact[...] fields and do not compete for that line.

   EVERY STORAGE TOUCH IS GUARDED. Safari in private mode and a browser set to
   block site data both THROW on sessionStorage rather than returning null, and
   an uncaught throw here would abort the listener that stores the value. */
(function () {
  'use strict';

  var KEY = 'tidelQuoteReference';

  /* No 0, O, 1, I or L - the pairs a customer misreads when reading the
     reference down a phone. 31 characters, so 31^4 = 923,521 per UTC day. */
  var ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';

  function guarded(fn) {
    try {
      return fn();
    } catch (e) {
      return null;
    }
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* Rejection sampling: 256 % 31 is 8, so a bare modulo would make the first
     eight characters of the alphabet slightly likelier than the rest. */
  function randomChars(count) {
    var crypto = window.crypto || window.msCrypto;
    var ceiling = 256 - (256 % ALPHABET.length);
    var out = '';
    var buffer = null;
    var index = 0;
    var value;

    while (out.length < count) {
      if (crypto && crypto.getRandomValues) {
        if (!buffer || index >= buffer.length) {
          buffer = new Uint8Array(16);
          crypto.getRandomValues(buffer);
          index = 0;
        }
        value = buffer[index++];
        if (value >= ceiling) continue;
      } else {
        value = Math.floor(Math.random() * ceiling);
      }
      out += ALPHABET.charAt(value % ALPHABET.length);
    }

    return out;
  }

  /* UTC, so the date segment is the same for every customer on a given day
     rather than depending on where they happen to be. */
  function makeReference() {
    var now = new Date();
    return 'TQ-' +
      pad(now.getUTCFullYear() % 100) +
      pad(now.getUTCMonth() + 1) +
      pad(now.getUTCDate()) +
      '-' + randomChars(4);
  }

  function showStoredReference(display) {
    var value = guarded(function () {
      return window.sessionStorage.getItem(KEY);
    });
    if (!value) return;

    /* Dropped once shown, so a later submission whose store failed cannot
       surface the PREVIOUS reference as if it were the new one. */
    guarded(function () {
      window.sessionStorage.removeItem(KEY);
      return null;
    });

    var slot = display.querySelector('[data-tidel-quote-reference-value]');
    if (!slot) return;

    slot.textContent = value;
    display.hidden = false;
  }

  function armForm(form) {
    /* The theme editor replaces the section node and re-fires init, so without
       this a second hidden input would be added on every settings change. */
    if (form.querySelector('input[name="contact[Reference]"]')) return;

    var reference = makeReference();
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'contact[Reference]';
    input.value = reference;
    form.insertBefore(input, form.firstChild);

    form.addEventListener('submit', function () {
      guarded(function () {
        window.sessionStorage.setItem(KEY, reference);
        return null;
      });
    });
  }

  function init() {
    var display = document.querySelector('[data-tidel-quote-reference]');
    if (display) {
      showStoredReference(display);
      return;
    }

    var form = document.querySelector('form.tidel-quote-form--page');
    if (form) armForm(form);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
